var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-apex-chart',{ref:"apexchart",attrs:{"dir":"ltr","type":_vm.type,"height":_vm.height,"options":_vm.chartOptions,"series":_vm.series}})
}
var staticRenderFns = []

export { render, staticRenderFns }